export const suggestionAddress={

    suggestions: [
    
        {
            "street_line": "11111 Barrett Rd",
            "secondary": "",
            "city": "Roland",
            "state": "AR",
            "zipcode": "72135",
            "entries": 0
        },
        {
            "street_line": "11111 Bluebird Sardis",
            "secondary": "",
            "city": "Mabelvale",
            "state": "AR",
            "zipcode": "72103",
            "entries": 0
        },
         {
            "street_line": "PO BOX 65467",
            "secondary": "",
            "city": "Roland",
            "state": "AR",
            "zipcode": "72135",
            "entries": 0
        },
        {
            "street_line": "PO BOX 65480",
            "secondary": "",
            "city": "Mabelvale",
            "state": "AR",
            "zipcode": "72103",
            "entries": 0
        },
        {
            "street_line": "11111 Charlotte Dr",
            "secondary": "",
            "city": "Mabelvale",
            "state": "AR",
            "zipcode": "72103",
            "entries": 0
        },
        {
            "street_line": "11111 Dingledine Rd",
            "secondary": "",
            "city": "Fayetteville",
            "state": "AR",
            "zipcode": "72701",
            "entries": 0
        },
        {
            "street_line": "11111 Dogwood Forest Dr",
            "secondary": "",
            "city": "Pine Bluff",
            "state": "AR",
            "zipcode": "71603",
            "entries": 0
        },
        {
            "street_line": "11111 Donnie Dr",
            "secondary": "",
            "city": "Mabelvale",
            "state": "AR",
            "zipcode": "72103",
            "entries": 0
        },
        {
            "street_line": "11111 Dubuque Rd",
            "secondary": "",
            "city": "Omaha",
            "state": "AR",
            "zipcode": "72662",
            "entries": 0
        },
        {
            "street_line": "11111 Fishback Rd",
            "secondary": "",
            "city": "Gravette",
            "state": "AR",
            "zipcode": "72736",
            "entries": 0
        },
        {
            "street_line": "11111 Geyer Springs Rd",
            "secondary": "",
            "city": "Little Rock",
            "state": "AR",
            "zipcode": "72209",
            "entries": 0
        },
        {
            "street_line": "11111 Harper Rd",
            "secondary": "",
            "city": "Little Rock",
            "state": "AR",
            "zipcode": "72206",
            "entries": 0
        },
        {
            "street_line": "22222 Bayshore Dr",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99515",
            "entries": 0
        },
        {
            "street_line": "22222 Bulwark Cir",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99515",
            "entries": 0
        },
        {
            "street_line": "PO BOX 22222",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99515",
            "entries": 0
        },
        {
            "street_line": "PO BOX 23444",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99515",
            "entries": 0
        },
        {
            "street_line": "22222 E Equestrian Cir",
            "secondary": "",
            "city": "Palmer",
            "state": "AK",
            "zipcode": "99645",
            "entries": 0
        },
        {
            "street_line": "22222 E Equestrian St",
            "secondary": "",
            "city": "Palmer",
            "state": "AK",
            "zipcode": "99645",
            "entries": 0
        },
        {
            "street_line": "22222 Forest Dr",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99516",
            "entries": 0
        },
        {
            "street_line": "22222 Navrot Cir",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99516",
            "entries": 0
        },
        {
            "street_line": "22222 Old Eagle River Rd",
            "secondary": "",
            "city": "Eagle River",
            "state": "AK",
            "zipcode": "99577",
            "entries": 0
        },
        {
            "street_line": "22222 Omalley Centre Dr",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99515",
            "entries": 0
        },
        {
            "street_line": "22222 Polar Dr",
            "secondary": "",
            "city": "Anchorage",
            "state": "AK",
            "zipcode": "99516",
            "entries": 0
        },
        {
            "street_line": "PO BOX 3333",
            "secondary": "",
            "city": "Henderson",
            "state": "NV",
            "zipcode": "89052",
            "entries": 0
        },
        {
            "street_line": "PO BOX 3335",
            "secondary": "",
            "city": "Reno",
            "state": "NV",
            "zipcode": "89521",
            "entries": 0
        },
        {
            "street_line": "33333 African Sunset St",
            "secondary": "",
            "city": "Henderson",
            "state": "NV",
            "zipcode": "89052",
            "entries": 0
        },
        {
            "street_line": "33333 Bandero Heights Ln",
            "secondary": "",
            "city": "Reno",
            "state": "NV",
            "zipcode": "89521",
            "entries": 0
        },
        {
            "street_line": "33333 Bandon Dunes Ct",
            "secondary": "",
            "city": "Las Vegas",
            "state": "NV",
            "zipcode": "89141",
            "entries": 0
        },
        {
            "street_line": "33333 Copper Valley Ct",
            "secondary": "",
            "city": "Reno",
            "state": "NV",
            "zipcode": "89511",
            "entries": 0
        },
        {
            "street_line": "33333 Deluna St",
            "secondary": "",
            "city": "Las Vegas",
            "state": "NV",
            "zipcode": "89141",
            "entries": 0
        },
        {
            "street_line": "33333 Diamond Stream Dr",
            "secondary": "",
            "city": "Sparks",
            "state": "NV",
            "zipcode": "89441",
            "entries": 0
        },
        {
            "street_line": "33333 Luna Blanca Dr",
            "secondary": "",
            "city": "Las Vegas",
            "state": "NV",
            "zipcode": "89138",
            "entries": 0
        },
        {
            "street_line": "33333 Magallanes St",
            "secondary": "",
            "city": "Las Vegas",
            "state": "NV",
            "zipcode": "89179",
            "entries": 0
        },
        {
            "street_line": "33333 Moonlight Fire Ct",
            "secondary": "",
            "city": "Las Vegas",
            "state": "NV",
            "zipcode": "89135",
            "entries": 0
        },
        {
            "street_line": "33333 Powerline Rd",
            "secondary": "",
            "city": "Fallon",
            "state": "NV",
            "zipcode": "89406",
            "entries": 0
        },
        {
            "street_line": "12344 Brooklyn Rd",
            "secondary": "",
            "city": "Andalusia",
            "state": "AL",
            "zipcode": "36421",
            "entries": 0
        },
        {
            "street_line": "12344 Choctaw Cir",
            "secondary": "",
            "city": "Moundville",
            "state": "AL",
            "zipcode": "35474",
            "entries": 0
        },
        {
            "street_line": "12344 County Road 43",
            "secondary": "",
            "city": "Andalusia",
            "state": "AL",
            "zipcode": "36421",
            "entries": 0
        },
        {
            "street_line": "12344 County Road 49",
            "secondary": "",
            "city": "Winfield",
            "state": "AL",
            "zipcode": "35594",
            "entries": 0
        },
        {
            "street_line": "12344 County Road 75",
            "secondary": "",
            "city": "Ethelsville",
            "state": "AL",
            "zipcode": "35461",
            "entries": 0
        },
        {
            "street_line": "12344 Fernwood Cir",
            "secondary": "",
            "city": "Foley",
            "state": "AL",
            "zipcode": "36535",
            "entries": 0
        },
        {
            "street_line": "12344 Grand Bay Farms Ln",
            "secondary": "",
            "city": "Grand Bay",
            "state": "AL",
            "zipcode": "36541",
            "entries": 0
        },
        {
            "street_line": "PO BOX 12344",
            "secondary": "",
            "city": "Andalusia",
            "state": "AL",
            "zipcode": "36421",
            "entries": 0
        },
        {
            "street_line": "PO BOX 12346",
            "secondary": "",
            "city": "Moundville",
            "state": "AL",
            "zipcode": "35474",
            "entries": 0
        },
        {
            "street_line": "PO BOX 12349",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30004",
            "entries": 0
        },
        {
            "street_line": "PO BOX 12349",
            "secondary": "",
            "city": "Jasper",
            "state": "GA",
            "zipcode": "30143",
            "entries": 0
        },
        {
            "street_line": "12345 Beragio Pl",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30004",
            "entries": 0
        },
        {
            "street_line": "12345 Big Canoe",
            "secondary": "",
            "city": "Jasper",
            "state": "GA",
            "zipcode": "30143",
            "entries": 0
        },
        {
            "street_line": "12345 Broadleaf Ln",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30005",
            "entries": 0
        },
        {
            "street_line": "12345 Charlotte Dr",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30004",
            "entries": 0
        },
        {
            "street_line": "12345 Clairmonte Ave",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30009",
            "entries": 0
        },
        {
            "street_line": "12345 Crabapple Chase Dr",
            "secondary": "",
            "city": "Alpharetta",
            "state": "GA",
            "zipcode": "30004",
            "entries": 0
        },
        {
            "street_line": "12345 Etris Rd",
            "secondary": "",
            "city": "Roswell",
            "state": "GA",
            "zipcode": "30075",
            "entries": 0
        },
        {
            "street_line": "PO BOX 12345",
            "secondary": "Apt 1",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "PO BOX 12340",
            "secondary": "Apt 2",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 1",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 2",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 3",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 4",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 5",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 6",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 7",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },
        {
            "street_line": "1117 12th Ave",
            "secondary": "Apt 8",
            "city": "Honolulu",
            "state": "HI",
            "zipcode": "96816",
            "entries": 1
        },   
        {
            "street_line": "12000 25 Mesa Rd",
            "secondary": "",
            "city": "Delta",
            "state": "CO",
            "zipcode": "81416",
            "entries": 0
        },
        {
            "street_line": "12000 Auckland Ave",
            "secondary": "",
            "city": "Florence",
            "state": "CO",
            "zipcode": "81226",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 154",
            "secondary": "",
            "city": "Kiowa",
            "state": "CO",
            "zipcode": "80117",
            "entries": 0
        },
        {
            "street_line": "PO BOX 204",
            "secondary": "# 12000",
            "city": "De Beque",
            "state": "CO",
            "zipcode": "81630",
            "entries": 0
        },
        {
            "street_line": "PO BOX 209",
            "secondary": "",
            "city": "De Beque",
            "state": "CO",
            "zipcode": "81630",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 204",
            "secondary": "# 12000",
            "city": "De Beque",
            "state": "CO",
            "zipcode": "81630",
            "entries": 1
        },
        {
            "street_line": "12000 County Road 204",
            "secondary": "",
            "city": "De Beque",
            "state": "CO",
            "zipcode": "81630",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 21.5",
            "secondary": "",
            "city": "Sterling",
            "state": "CO",
            "zipcode": "80751",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 263",
            "secondary": "",
            "city": "Nathrop",
            "state": "CO",
            "zipcode": "81236",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 3",
            "secondary": "",
            "city": "Parshall",
            "state": "CO",
            "zipcode": "80468",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 302",
            "secondary": "",
            "city": "Buena Vista",
            "state": "CO",
            "zipcode": "81211",
            "entries": 0
        },
        {
            "street_line": "12000 County Road 37",
            "secondary": "",
            "city": "Cheyenne Wells",
            "state": "CO",
            "zipcode": "80810",
            "entries": 0
        },
        {
            "street_line": "11000 100th Ave",
            "secondary": "",
            "city": "Seminole",
            "state": "FL",
            "zipcode": "33772",
            "entries": 0
        },
        {
            "street_line": "11000 110th Ave",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33778",
            "entries": 0
        },
        {
            "street_line": "11000 1st St E",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33706",
            "entries": 0
        },
        {
            "street_line": "11000 47th Ave N",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "11000 49th Ave N",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "PO BOX 65676",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "PO BOX 65670",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "11000 4th St E",
            "secondary": "# 11000",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33706",
            "entries": 1
        },
        {
            "street_line": "11000 4th St E",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33706",
            "entries": 0
        },
        {
            "street_line": "11000 52nd Ave N",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "11000 53rd Ave N",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "11000 54th Ave N",
            "secondary": "",
            "city": "Saint Petersburg",
            "state": "FL",
            "zipcode": "33708",
            "entries": 0
        },
        {
            "street_line": "PO BOX 45553",
            "secondary": "# 11000",
            "city": "Charlotte",
            "state": "NC",
            "zipcode": "28227",
            "entries": 1
        },
        {
            "street_line": "PO BOX 45559",
            "secondary": "",
            "city": "Charlotte",
            "state": "NC",
            "zipcode": "28227",
            "entries": 0
        },
        {
            "street_line": "11000 Albemarle Rd",
            "secondary": "# 11000",
            "city": "Charlotte",
            "state": "NC",
            "zipcode": "28227",
            "entries": 1
        },
        {
            "street_line": "11000 Albemarle Rd",
            "secondary": "",
            "city": "Charlotte",
            "state": "NC",
            "zipcode": "28227",
            "entries": 0
        },
        {
            "street_line": "11000 Asbury Chapel Rd",
            "secondary": "# 11000",
            "city": "Huntersville",
            "state": "NC",
            "zipcode": "28078",
            "entries": 1
        },
        {
            "street_line": "11000 Asbury Chapel Rd",
            "secondary": "",
            "city": "Huntersville",
            "state": "NC",
            "zipcode": "28078",
            "entries": 0
        },
        {
            "street_line": "11000 Aspen Ridge Ln NW",
            "secondary": "",
            "city": "Concord",
            "state": "NC",
            "zipcode": "28027",
            "entries": 0
        },
        {
            "street_line": "11000 Astoria Dr",
            "secondary": "",
            "city": "Charlotte",
            "state": "NC",
            "zipcode": "28262",
            "entries": 0
        },
        {
            "street_line": "11000 Atrium Way",
            "secondary": "# 11000",
            "city": "Matthews",
            "state": "NC",
            "zipcode": "28105",
            "entries": 1
        },
        {
            "street_line": "11000 Atrium Way",
            "secondary": "",
            "city": "Matthews",
            "state": "NC",
            "zipcode": "28105",
            "entries": 0
        },
        {
            "street_line": "11000 Ballards Pond Ln",
            "secondary": "",
            "city": "Matthews",
            "state": "NC",
            "zipcode": "28105",
            "entries": 0
        },
        {
            "street_line": "11000 Barnes Bridge Rd",
            "secondary": "",
            "city": "Laurinburg",
            "state": "NC",
            "zipcode": "28352",
            "entries": 0
        },
        {
            "street_line": "PO BOX 453",
            "secondary": "",
            "city": "Red House",
            "state": "WV",
            "zipcode": "25168",
            "entries": 0
        },
        {
            "street_line": "PO BOX 45309",
            "secondary": "",
            "city": "Littleton",
            "state": "WV",
            "zipcode": "26581",
            "entries": 0
        },
        {
            "street_line": "11001 Charleston Rd",
            "secondary": "",
            "city": "Red House",
            "state": "WV",
            "zipcode": "25168",
            "entries": 0
        },
        {
            "street_line": "11001 Hornet Hwy",
            "secondary": "",
            "city": "Littleton",
            "state": "WV",
            "zipcode": "26581",
            "entries": 0
        },
        {
            "street_line": "11001 Maccorkle Ave",
            "secondary": "# A",
            "city": "Charleston",
            "state": "WV",
            "zipcode": "25315",
            "entries": 1
        },
        {
            "street_line": "11001 Maccorkle Ave",
            "secondary": "",
            "city": "Charleston",
            "state": "WV",
            "zipcode": "25315",
            "entries": 0
        },
        {
            "street_line": "11001 Silverbell Dr",
            "secondary": "",
            "city": "Morgantown",
            "state": "WV",
            "zipcode": "26508",
            "entries": 0
        },
        {
            "street_line": "11001 Teaberry Ln",
            "secondary": "",
            "city": "Morgantown",
            "state": "WV",
            "zipcode": "26508",
            "entries": 0
        },
        {
            "street_line": "13000 110th Ave",
            "secondary": "# 13000",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33774",
            "entries": 1
        },
        {
            "street_line": "13000 110th Ave",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33774",
            "entries": 0
        },
        {
            "street_line": "13000 115th St",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33778",
            "entries": 0
        },
        {
            "street_line": "13000 116th St",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33778",
            "entries": 0
        },
        {
            "street_line": "13000 119th St",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33778",
            "entries": 0
        },
        {
            "street_line": "13000 120th St",
            "secondary": "",
            "city": "Largo",
            "state": "FL",
            "zipcode": "33778",
            "entries": 0
        },
        {
            "street_line": "13000 34th St N",
            "secondary": "",
            "city": "Clearwater",
            "state": "FL",
            "zipcode": "33762",
            "entries": 0
        },
        {
            "street_line": "13000 42nd Rd N",
            "secondary": "",
            "city": "West Palm Beach",
            "state": "FL",
            "zipcode": "33411",
            "entries": 0
        },
        {
            "street_line": "13000 51st Pl N",
            "secondary": "Unit 13220",
            "city": "West Palm Beach",
            "state": "FL",
            "zipcode": "33411",
            "entries": 1
        }

    ]
}

